import { useEffect } from "react";

const STORAGE_KEY = "frontier_newsletter_seen";
const ARM_DELAY_MS = 5000; // grace period before arming

/**
 * Detects when a desktop user is about to close/leave the tab and fires
 * the trigger once per visitor. Stores a localStorage flag so it never
 * fires again — including for users who've already subscribed.
 */
export function useExitIntent(trigger, { enabled = true } = {}) {
    useEffect(() => {
        if (!enabled) return;
        if (typeof window === "undefined") return;
        if (localStorage.getItem(STORAGE_KEY)) return;

        let armed = false;
        const armTimer = setTimeout(() => {
            armed = true;
        }, ARM_DELAY_MS);

        const onLeave = (e) => {
            if (!armed) return;
            // Only fire when cursor exits the top of the viewport (browser chrome direction)
            if (e.clientY > 0) return;
            // Ignore exits caused by entering iframes/child windows
            if (e.relatedTarget) return;
            try {
                localStorage.setItem(STORAGE_KEY, "1");
            } catch (err) {
                console.warn("ExitIntent: localStorage write failed", err);
            }
            trigger();
            document.removeEventListener("mouseleave", onLeave);
        };

        document.addEventListener("mouseleave", onLeave);
        return () => {
            clearTimeout(armTimer);
            document.removeEventListener("mouseleave", onLeave);
        };
    }, [enabled, trigger]);
}

/** Marks the visitor as having seen/handled the newsletter prompt. */
export function markNewsletterSeen() {
    try {
        localStorage.setItem(STORAGE_KEY, "1");
    } catch {
        /* ignore quota / private mode */
    }
}
